import { Users } from "lucide-react";
import { useLang } from "../i18n";
import { Eyebrow, Reveal } from "./Reveal";

export default function Fleet() {
  const { t } = useLang();
  const caps = [t.fleet.cap1, t.fleet.cap2, t.fleet.cap3];
  return (
    <section id="fleet" className="bg-night py-24 lg:py-28">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <Reveal>
          <Eyebrow>{t.fleet.eyebrow}</Eyebrow>
          <h2
            data-testid="fleet-heading"
            className="mt-5 max-w-2xl font-serif text-4xl text-white sm:text-5xl"
          >
            {t.fleet.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {t.fleet.items.map((f, i) => (
            <Reveal key={f.t} delay={i * 0.08} className="h-full">
              <div
                data-testid={`fleet-card-${i + 1}`}
                className="group h-full rounded-2xl border border-white/5 bg-coal p-7 transition-colors hover:border-gold/30"
              >
                <span className="inline-flex items-center gap-1.5 rounded-full border border-gold/30 px-3 py-1.5 text-[11px] font-semibold text-white">
                  <Users className="h-3.5 w-3.5 text-gold" />
                  {caps[i]}
                </span>
                <h3 className="mt-6 font-serif text-2xl text-white">{f.t}</h3>
                <p className="mt-2 text-sm text-white/60">{f.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
